import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PillValuesType } from "../services/scAPI";

export type SelectedtagType = {
  id: number | string;
  value: string;
  flowType?: "secondStepFilterSearchScreen" | "secondStepFilterScreen";
  paramName: string;
};

const searchMembersSlice = createSlice({
  name: "search",
  initialState: {
    searchMembers: [],
    scSearchTags: [],
    selectedTag: null,
  } as {
    scSearchTags: PillValuesType[];
    searchMembers: any;
    selectedTag: SelectedtagType | null;
  },
  reducers: {
    setSearchMembers: (state, { payload: { members, reset = false } }) => {
      if (reset) {
        state.searchMembers = members;
      } else {
        const mergedSearchMembers = [...state.searchMembers, ...members];
        state.searchMembers = mergedSearchMembers;
      }
    },

    setSelectedTag: (state, { payload: { tag } }) => {
      state.selectedTag = tag;
    },

    setScSearchTags: (
      state,
      {
        payload: { tag, paramName, reset = false },
      }: PayloadAction<{
        tag?: PillValuesType;
        paramName?: string;
        reset?: boolean;
      }>
    ) => {
      if (reset) {
        state.scSearchTags = [];
      } else {
        if (
          state.scSearchTags.find((item) => {
            if (item.id === tag?.id && item.value === tag?.value) {
              return item;
            }
          })
        ) {
          const newTags = state.scSearchTags.filter((item) => {
            if (item.id !== tag?.id || item.value !== tag?.value) {
              return item;
            }
          });

          state.scSearchTags = newTags;
        } else {
          state.scSearchTags = [...state.scSearchTags!, tag!];
        }
      }
    },

    setSearchMemberConnectionStatus: (
      state,
      { payload: { memberId = "" } }
    ) => {
      const updatedMembers = state.searchMembers.map((member) => {
        if (member?._id === memberId || member?.mongo_id === memberId) {
          return {
            ...member,
            connected: true,
          };
        }
        return member;
      });
      state.searchMembers = updatedMembers;
    },
  },
});

export const {
  setSearchMembers,
  setSearchMemberConnectionStatus,
  setScSearchTags,
  setSelectedTag,
} = searchMembersSlice.actions;

export default searchMembersSlice.reducer;
